import { toEnglishDigits } from '../../../report.utils';
import { RouteSummaryColumn, RouteSummaryRow } from './route-summary-report.models';

export const SUMMARY_PAGE_SIZES = [10, 20, 50];
export const SUMMARY_PAGE_SIZE = 20;
export function summaryColumns(type: string): RouteSummaryColumn[] {
  const totals: RouteSummaryColumn[] = [
    { field: 'iCount', title: type === '22' ? 'تعداد مرتبه طی شده' : 'عملکرد', numeric: true, total: 'count' },
    { field: 'cost', title: 'هزینه (ریال)', numeric: true, total: 'cost', unit: 'ریال' },
  ];
  return type === '22' ? [
    { field: 'strDate', title: 'تاریخ' }, { field: 'strFullName', title: 'راننده' },
    { field: 'strMobileType_strComment', title: 'نوع خودرو' }, { field: 'strVehicleNo', title: 'پلاک' },
    { field: 'strRoute_strName', title: 'نام مسیر' }, { field: 'strDayName', title: 'روز' }, ...totals,
    { field: 'strTeme', title: 'جمع مدت زمان سفر', total: 'hours', unit: 'ساعت' },
    { field: 'fLength', title: 'جمع پیمایش طی مسیر (km)', numeric: true, total: 'length', unit: 'کیلومتر' },
  ] : [
    { field: 'strRoute_strName', title: 'مسیر' }, { field: 'strDestinationStationName', title: 'مقصد' },
    { field: 'strSourceStationName', title: 'مبدأ' }, { field: 'strFullName', title: 'نام راننده' },
    { field: 'strVehicleNo', title: 'پلاک' }, { field: 'strMobileType_strComment', title: 'نوع خودرو' }, ...totals,
  ];
}
export function summaryValue(row: RouteSummaryRow, column: RouteSummaryColumn): string | number {
  if (column.field === 'cost') return (Number(row.iCount) || 0) * (Number(row.iCost) || 0);
  const value = row[column.field];
  return column.numeric ? Number(value) || 0 : String(value ?? '');
}
export function summarySearchIndex(row: RouteSummaryRow, columns: RouteSummaryColumn[]): string {
  return toEnglishDigits(columns.map(column => summaryValue(row, column)).join(' ')).toLowerCase();
}
export function summaryTotals(rows: RouteSummaryRow[]): Record<NonNullable<RouteSummaryColumn['total']>, number> {
  return rows.reduce((totals, row) => ({
    count: totals.count + (Number(row.iCount) || 0),
    cost: totals.cost + (Number(row.iCount) || 0) * (Number(row.iCost) || 0),
    hours: totals.hours + (Number(row.iTime) || 0) / 3600,
    length: totals.length + (Number(row.fLength) || 0),
  }), { count: 0, cost: 0, hours: 0, length: 0 });
}
